/**
 *
 *
 */
export function appendStyleToBody(styleCode: string) {
  const style = document.createElement('style')
  style.innerHTML = styleCode
  /*                                                                                        */
  document.body.appendChild(style)
}
